import ChatViewCart from "@/components/chat/ChatViewCart";
import { Check } from "@/components/ui";

// Figma 3151:8011 at rest. Hover (only where the device has it) and keyboard focus read
// View cart instead, so a touch screen never keeps a stuck hover state.
const BAR =
  "unset group flex h-[44px] w-full cursor-pointer items-center justify-center rounded-ds-corner-small bg-ds-background-black px-[var(--chat-space-04)] text-ds-header-subheader uppercase text-ds-text-white no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ds-ui-elements-black";

/** The plan card's ADDED! bar: it opens the cart as ChatViewCart does. */
export default function ChatProgramAddedBar({
  className = "",
}: {
  className?: string;
}) {
  return (
    <ChatViewCart label="Added. View cart" className={`${BAR} ${className}`}>
      <span className="flex items-center gap-[var(--chat-space-03)] group-focus-visible:hidden [@media(hover:hover)]:group-hover:hidden">
        <Check className="shrink-0" />
        Added!
      </span>
      <span className="hidden group-focus-visible:inline [@media(hover:hover)]:group-hover:inline">
        View cart
      </span>
    </ChatViewCart>
  );
}
